import {Component} from '@angular/core';
import {
  heroCheckCircleSolid,
  heroExclamationCircleSolid,
  heroInformationCircleSolid,
  heroXCircleSolid
} from '@ng-icons/heroicons/solid';

@Component({
    selector: 'app-toast',
    templateUrl: './toast.component.html',
    styleUrl: './toast.component.css',
    standalone: false
})
export class ToastComponent {

  getBackgroundClass(severity: string): string {
    switch (severity) {
      case 'success':
        return 'bg-green-50';
      case 'warn':
        return 'bg-yellow-50';
      case 'error':
        return 'bg-red-50';
      case 'info':
      default:
        return 'bg-blue-50';
    }
  }

  getTextSummaryClass(severity: string): string {
    switch (severity) {
      case 'success':
        return 'text-green-800';
      case 'warn':
        return 'text-yellow-800';
      case 'error':
        return 'text-red-800';
      case 'info':
      default:
        return 'text-blue-800';
    }
  }

  getTextDetailClass(severity: string): string {
    switch (severity) {
      case 'success':
        return 'text-green-700';
      case 'warn':
        return 'text-yellow-700';
      case 'error':
        return 'text-red-700';
      case 'info':
      default:
        return 'text-blue-700';
    }
  }

  getIconClass(severity: string): string {
    switch (severity) {
      case 'success':
        return 'text-green-400';
      case 'warn':
        return 'text-yellow-400';
      case 'error':
        return 'text-red-400';
      case 'info':
      default:
        return 'text-blue-400';
    }
  }

  getButtonClass(severity: string): string {
    switch (severity) {
      case 'success':
        return 'bg-green-50 text-green-500 hover:bg-green-100 focus:ring-green-600 focus:ring-offset-green-50';
      case 'warn':
        return 'bg-yellow-50 text-yellow-500 hover:bg-yellow-100 focus:ring-yellow-600 focus:ring-offset-yellow-50';
      case 'error':
        return 'bg-red-50 text-red-500 hover:bg-red-100 focus:ring-red-600 focus:ring-offset-red-50';
      case 'info':
      default:
        return 'bg-info-50 text-info-500 hover:bg-info-100 focus:ring-info-600 focus:ring-offset-info-50';
    }
  }

  getIcon(severity: string): string {
    switch (severity) {
      case 'success':
        return heroCheckCircleSolid;
      case 'warn':
        return heroExclamationCircleSolid;
      case 'error':
        return heroXCircleSolid;
      case 'info':
      default:
        return heroInformationCircleSolid;
    }
  }
}
